import type { zoomError } from '@lib/zoom/types';

type ZoomErrorCodes = Record<number | string, zoomError>;

export const ZOOM_ERROR_CODES_AUTHORIZED: ZoomErrorCodes = {
  3051: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'Require login',
    errorCode: 3051,
    message: 'StreamAlive couldn\'t join because your meeting requires login. Follow these instructions to troubleshoot.',
    helpUrl: 'https://help.streamalive.com/en/articles/11469104-authorizing-streamalive-access-to-your-zoom'
  },
  3099: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'This webinar requires registration.',
    errorCode: 3099,
    message: 'This Zoom webinar requires a user to register before allowing access. Follow these instructions to troubleshoot.',
    helpUrl: 'https://help.streamalive.com/en/articles/11332308-streamalive-zoom-connection-troubleshooting-guide#h_92f7a955f9'
  }
};
